export default __webpack_public_path__ + "static/media/24-7-icon.d8cbba70.svg";